(() => {
  const navContainer = document.querySelector('[data-nav-container]');
  const menuItems = document.querySelectorAll('[data-menu-item]');

  if (!navContainer) return;

  // Debounce helper function
  let repositionTimeout;
  const debounceReposition = (fn, delay = 10) => {
    clearTimeout(repositionTimeout);
    repositionTimeout = setTimeout(() => {
      requestAnimationFrame(fn);
    }, delay);
  };

  // Cache for button positions
  const positionCache = new Map();

  // Calculate viewport width excluding scrollbar
  const getViewportWidth = () => document.documentElement.clientWidth;

  // Position mega menu dropdowns based on button position
  const positionMegaMenus = (forceUpdate = false) => {
    const mainHeader = document.getElementById('main-header');
    const megaMenuDropdowns = document.querySelectorAll(
      '[data-mega-menu-dropdown]'
    );

    if (!mainHeader) return;

    const headerRect = mainHeader.getBoundingClientRect();
    const viewportWidth = getViewportWidth() - 80;

    megaMenuDropdowns.forEach(dropdown => {
      const buttonId = dropdown.getAttribute('data-menu-button-id');
      const button = document.getElementById(buttonId);

      if (button) {
        const buttonRect = button.getBoundingClientRect();
        const leftOffset = headerRect.left - buttonRect.left;

        // Check if position has changed from cache
        const cachedPosition = positionCache.get(buttonId);
        const newLeft = `${leftOffset}px`;

        if (forceUpdate || cachedPosition !== newLeft) {
          Object.assign(dropdown.style, {
            left: newLeft,
            width: `${viewportWidth}px`,
          });
          positionCache.set(buttonId, newLeft);
        }
      }
    });
  };

  // Initial positioning after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionMegaMenus);
  } else {
    requestAnimationFrame(positionMegaMenus);
  }

  // Create MutationObserver to watch for DOM changes
  const observer = new MutationObserver(mutations => {
    // Check if any relevant changes occurred
    let shouldReposition = false;

    mutations.forEach(mutation => {
      // Check for attribute changes on nav container or menu items
      if (mutation.type === 'attributes') {
        const { target } = mutation;
        if (
          target.hasAttribute('data-nav-container') ||
          target.hasAttribute('data-menu-item') ||
          target.hasAttribute('data-mega-menu-dropdown')
        ) {
          shouldReposition = true;
        }
      }

      // Check for added/removed nodes that might affect layout
      if (mutation.type === 'childList') {
        shouldReposition = true;
      }
    });

    if (shouldReposition) {
      debounceReposition(positionMegaMenus);
    }
  });

  // Observe the header and nav container for changes
  const mainHeader = document.getElementById('main-header');
  if (mainHeader) {
    observer.observe(mainHeader, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style'],
    });
  }

  // Also use ResizeObserver for more precise layout changes
  const resizeObserver = new ResizeObserver(() => {
    debounceReposition(positionMegaMenus);
  });

  // Observe the main header for size changes
  if (mainHeader) {
    resizeObserver.observe(mainHeader);
  }

  // Use IntersectionObserver to track visibility and position only when visible
  const visibilityObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Menu is visible, position it
          requestAnimationFrame(positionMegaMenus);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }
  );

  // Observe all menu buttons for visibility
  const menuButtons = document.querySelectorAll('[data-desktop-menu-button]');
  menuButtons.forEach(button => {
    visibilityObserver.observe(button);
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    observer.disconnect();
    resizeObserver.disconnect();
    visibilityObserver.disconnect();
  });

  // Call positionMegaMenus every 1s, up to 5 times, then stop
  let positionCount = 0;
  const maxPositions = 5;
  const intervalId = setInterval(() => {
    positionMegaMenus();
    positionCount += 1;
    if (positionCount >= maxPositions) {
      clearInterval(intervalId);
    }
  }, 1000);

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  let isHeaderShown = false;

  const showHeaderWithStagger = () => {
    if (isHeaderShown) return;
    isHeaderShown = true;

    if (prefersReducedMotion) {
      // No animation - show everything immediately
      navContainer.classList.add('is-visible');
      menuItems.forEach(item => {
        item.classList.add('is-visible');
      });
      return;
    }

    // Slide container down
    navContainer.classList.add('is-visible');

    // Stagger menu items after container animation (600ms)
    menuItems.forEach((item, index) => {
      setTimeout(
        () => {
          item.classList.add('is-visible');
        },
        600 + index * 80
      );
    });
  };

  // Show header with slide-down stagger animation
  // Listen to both desktop and mobile lottie events
  window.addEventListener('lottie-menu-show', showHeaderWithStagger);
  window.addEventListener('lottie-menu-show-mobile', showHeaderWithStagger);

  // Fallback: Check if animation container exists and handle edge cases
  const initFallback = () => {
    const hasDesktopLottie = document.getElementById('lottie-font-container');
    const hasMobileLottie = document.getElementById(
      'lottie-font-container-mobile'
    );

    // If no lottie animation container exists, show header immediately
    if (!hasDesktopLottie && !hasMobileLottie) {
      showHeaderWithStagger();
    }
  };

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFallback);
  } else {
    initFallback();
  }
})();
